/*
 * @Author: wzc
 * @Date: 2022-08-29 10:42:36
 * @LastEditors: wzc
 * 超赛平台 canvas生成图片的公共方法
 * @LastEditTime: 2022-08-29 19:11:02
 */
export default {
  data() {
    return {
      isDownLoadFlag: false,
    }
  },
  methods: {
    downLoad(dom, isCanvasParentDom) {
      // isCanvasParentDom: true 则dom是canvas的父节点； false则dom即使canvas本身
      // 将canvas生成的base64图片保存在本地
      //------------------------------------------------------------------------
      //1.确定图片的类型  获取到的图片格式 data:image/Png;base64,......
      //2.保存本地的图片尺寸为canvas尺寸的2倍
      if (this.isDownLoadFlag) {
        return
      }
      this.isDownLoadFlag = true
      let type = 'png' //你想要什么图片格式 就选什么吧
      let can = null
      if (isCanvasParentDom) {
        can = dom.getElementsByTagName('canvas')[0]
      } else {
        can = dom
      }
      let imgdata = can.toDataURL('image/' + type)
      console.debug(imgdata)
      let savaFile = function (data, filename) {
        // let save_link = document.createElementNS(
        // "http://www.w3.org/1999/xhtml",
        // "a"
        // );
        let save_link = document.createElement('a')
        save_link.href = data
        save_link.download = filename
        let event = document.createEvent('MouseEvents')
        event.initMouseEvent(
          'click',
          true,
          false,
          window,
          0,
          0,
          0,
          0,
          0,
          false,
          false,
          false,
          false,
          0,
          null
        )
        save_link.dispatchEvent(event)
        save_link = null
      }
      let filename = '' + new Date().getTime() + '.' + type
      //注意咯 由于图片下载的比较少 就直接用当前几号做的图片名字
      savaFile(imgdata, filename)
      setTimeout(() => {
        this.isDownLoadFlag = false
      }, 1000)
    },
    upLoad(dom, isCanvasParentDom, emitEventName, legendData) {
      // isCanvasParentDom: true 则dom是canvas的父节点； false则dom即使canvas本身
      // 将canvas生成base64图片

      let type = 'png' //你想要什么图片格式 就选什么吧
      let can = null
      console.debug(emitEventName)
      if (isCanvasParentDom) {
        can = dom.getElementsByTagName('canvas')[0]
      } else {
        can = dom
      }
      const imgdata = can.toDataURL('image/' + type)
      if (emitEventName) {
        let data = null
        if (legendData) {
          data = {
            imgdata,
            legendData,
          }
        } else {
          data = {
            imgdata,
          }
        }
        this.$emit(emitEventName, data)
      } else {
        return imgdata //base64格式
      }
    },
  },
}
